// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_XkN","cls2":"FeedbackModal-cls2_tyM FeedbackModal-cls1_XkN"};